import { z } from "@core/zod";

export const UserScopeSchema = z.enum(["memory"]);

export const UserScopesSchema = z.array(UserScopeSchema);

export type UserScope = z.infer<typeof UserScopeSchema>;
